const endpoints = [
  { method: 'POST', path: '/api/auth/login', desc: 'Autentica com e-mail + senha do usuário.' },
  { method: 'POST', path: '/api/auth/register', desc: 'Cria um novo espaço (tenant) com o primeiro admin.' },
  { method: 'GET', path: '/api/users/me', desc: 'Retorna o usuário autenticado.' },
  { method: 'GET', path: '/api/users', desc: 'Lista usuários do tenant (admin).' },
  { method: 'GET', path: '/api/roles', desc: 'Matriz de permissões por perfil.' },
  { method: 'GET', path: '/api/dashboard', desc: 'Métricas do tenant.' },
  { method: 'GET', path: '/api/templates', desc: 'Lista templates do tenant (filtros por status/categoria).' },
  { method: 'POST', path: '/api/templates', desc: 'Cria template (admin/designer).' },
  { method: 'PATCH', path: '/api/templates/:id', desc: 'Atualiza template, inclusive o design (content).' },
  { method: 'DELETE', path: '/api/templates/:id', desc: 'Remove template.' },
];

const colors = {
  GET: 'bg-secondary-container text-on-secondary-container',
  POST: 'bg-primary-container text-on-primary-container',
  PATCH: 'bg-tertiary-container text-on-tertiary-container',
  DELETE: 'bg-error-container text-on-error-container',
};

export default function ApiDocs() {
  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Documentação da API</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Portal técnico para integrar sistemas externos via REST API do Studio.
        </p>
      </div>

      <div className="bg-surface rounded-2xl shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-surface-container-highest">
          <h3 className="studio-uniform-title font-h3 text-h3 text-on-surface">Endpoints</h3>
          <p className="text-[11px] text-on-surface-variant mt-1">
            Autenticação via <code className="bg-surface-container-low rounded px-1.5 py-0.5">Bearer</code> (JWT). Todas as rotas sío escopadas ao tenant do token.
          </p>
        </div>
        <ul className="divide-y divide-surface-container-highest">
          {endpoints.map((e) => (
            <li key={`${e.method}${e.path}`} className="px-6 py-4 flex items-center gap-4 hover:bg-surface-container-low transition-colors">
              <span className={`inline-flex items-center px-3 py-1 rounded-full font-label-sm text-label-sm w-20 justify-center ${colors[e.method]}`}>
                {e.method}
              </span>
              <code className="font-body-md text-body-md text-on-surface">{e.path}</code>
              <span className="text-[11px] text-on-surface-variant ml-auto">{e.desc}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}



